import React from 'react';
import * as Styled from './styles';
import { priceFormatter } from '../../../helpers/formatters';
import Currency from '../../../shared/components/Currency';
import { getStatusIcon, getTicketTypeIcon } from '../../../shared/helpers/popover';
import { TICKET_TYPES_ICONS } from '../../../constants/STATUS_ICONS';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import { isEmpty } from 'lodash';

interface ICommonPopoverProps {
  price: number;
  prices: string;
  statusIcon: string[];
  ticketType: number[];
  subtitle: string;
  text: string;
  isLanding?: boolean;
  title: string;
  isCategory?: boolean;
}

export const CommonPopover: React.FC<ICommonPopoverProps> = ({
  price,
  prices,
  statusIcon,
  ticketType,
  subtitle,
  text,
  isLanding,
  title,
  isCategory,
}) => {
  return (
    <>
      <Styled.HeaderWrapper>
        {title && !price && <Styled.Title>{title}</Styled.Title>}

        {price && !prices && (
          <Styled.Title>
            <Currency>
              {priceFormatter(price)} <CurrencyIcon height={11} />
            </Currency>
          </Styled.Title>
        )}

        <Styled.Icons>
          {!isEmpty(statusIcon) &&
            statusIcon?.map((status) => {
              return <Styled.StatusIcon>{getStatusIcon(status, isLanding)}</Styled.StatusIcon>;
            })}

          {!isEmpty(ticketType) &&
            ticketType?.map((type) => {
              return (
                TICKET_TYPES_ICONS[type] && (
                  <Styled.StatusIcon>{getTicketTypeIcon(type, isLanding)}</Styled.StatusIcon>
                )
              );
            })}
        </Styled.Icons>
      </Styled.HeaderWrapper>
      <Styled.Info>
        {subtitle ? <Styled.Subtitle isCategory={isCategory}>{subtitle}</Styled.Subtitle> : null}
        <Styled.Text>{text}</Styled.Text>
      </Styled.Info>
    </>
  );
};
